import { Monitor, Smartphone } from "lucide-react";
import { useState } from "react";

export default function DigestEmailPreview({ digest }) {
  const [mode, setMode] = useState("desktop"); // desktop | mobile
  if (!digest) {
    return (
      <div className="pp-card p-8 text-center text-sm text-[#C7CBD1]">
        No digest yet. Generate a preview from the panel on the left.
      </div>
    );
  }
  const widthClass = mode === "desktop" ? "max-w-[640px]" : "max-w-[380px]";
  return (
    <div className="pp-surface" data-testid="digest-email-preview">
      <div className="px-5 py-4 border-b border-[#333C47] flex items-center justify-between flex-wrap gap-3">
        <div className="min-w-0">
          <div className="pp-label mb-1">Email preview</div>
          <div className="font-display text-white text-lg truncate" data-testid="digest-preview-subject">
            {digest.subject}
          </div>
          <div className="text-xs text-[#C7CBD1] truncate mt-1">
            To {digest.recipient_email || "you"} · {digest.preheader}
          </div>
        </div>
        <div className="flex items-center gap-1 border border-[#333C47] p-1">
          <button
            onClick={() => setMode("desktop")}
            data-testid="preview-mode-desktop"
            className={`px-3 py-1.5 text-xs flex items-center gap-1.5 ${
              mode === "desktop" ? "bg-[#232931] text-white" : "text-[#C7CBD1]"
            }`}
          >
            <Monitor className="h-3.5 w-3.5" /> Desktop
          </button>
          <button
            onClick={() => setMode("mobile")}
            data-testid="preview-mode-mobile"
            className={`px-3 py-1.5 text-xs flex items-center gap-1.5 ${
              mode === "mobile" ? "bg-[#232931] text-white" : "text-[#C7CBD1]"
            }`}
          >
            <Smartphone className="h-3.5 w-3.5" /> Mobile
          </button>
        </div>
      </div>
      <div className="p-6 bg-[#0F1115] flex justify-center">
        <div
          className={`${widthClass} w-full border border-[#333C47] bg-[#0F1115]`}
          style={{ minHeight: 480 }}
        >
          <iframe
            title="Digest email preview"
            srcDoc={digest.body_html}
            className="w-full"
            style={{ height: 720, border: 0, background: "#0F1115" }}
            data-testid="digest-preview-iframe"
            sandbox=""
          />
        </div>
      </div>
    </div>
  );
}
